import { useState } from "react";
import Disclaimer from "../Disclaimer";
import PrivacyNotice from "../PrivacyNotice";
import LeftNavBar from "./left";
import TopNavbar from "./top";

function Index() {
  const [isDrawerOpen, setState] = useState(false);
  const [open, setOpen] = useState(false);
  const [openNotice, setOpenNotice] = useState(false);

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setState(open);
  };

  return (
    <>
      <TopNavbar toggleDrawer={toggleDrawer} />
      <LeftNavBar
        setOpen={setOpen}
        setOpenNotice={setOpenNotice}
        isDrawerOpen={isDrawerOpen}
        toggleDrawer={toggleDrawer}
      />
      <Disclaimer open={open} setOpen={setOpen} />
      <PrivacyNotice open={openNotice} setOpen={setOpenNotice} />
    </>
  );
}

export default Index;
